import type { StatusSelectColorRules } from "components/shared/StatusSelect/utils";
import type { PressChannelSlot } from "helpers/pressCalculationBase";
import { t } from "i18next";
import { ArticleCompletionStatus } from "store/articleStore";

export const completionStatusOptions = (): CompletionStatusOption[] => {
    const i18npath = "Articles.CompletionStatus.";
    return [
        { value: ArticleCompletionStatus.COMPLETED, label: t(i18npath + "Completed") },
        { value: ArticleCompletionStatus.PENDING, label: t(i18npath + "Pending") },
    ];
};

export const completionStatusColorRules = {
    [ArticleCompletionStatus.PENDING]: "#9B5067",
    [ArticleCompletionStatus.COMPLETED]: "#267847",
} as StatusSelectColorRules;

export const completionStatusFilterOptions = (): CompletionStatusFilterOptions[] => {
    return [{ value: "all", label: t("Filters.AllMasculine") }, ...completionStatusOptions()];
};

export type CompletionStatusOption = { value: ArticleCompletionStatus; label: string };
export type CompletionStatusFilterOptions = { value: ArticleCompletionStatus | "all"; label: string };

export type APaymentMethodOption = {
    pressSlot: PressChannelSlot;
    label: string;
    show?: boolean;
};
